import React from 'react'
import { FaRuler, FaCamera, FaFish, FaCloud, FaChartLine, FaShare } from 'react-icons/fa'

const Features = () => {
  const features = [
    {
      icon: <FaRuler className="h-8 w-8" />,
      title: 'One-Click AR Measurement',
      description: 'Measure fish instantly with just one tap using advanced augmented reality technology.',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      icon: <FaCamera className="h-8 w-8" />,
      title: 'AI Species ID',
      description: 'Instantly identify fish species using advanced AI recognition technology.',
      color: 'bg-green-100 text-green-600'
    },
    {
      icon: <FaFish className="h-8 w-8" />,
      title: 'Fish Database',
      description: 'Access comprehensive information on 100+ fish species including regulations.',
      color: 'bg-purple-100 text-purple-600'
    },
    {
      icon: <FaCloud className="h-8 w-8" />,
      title: 'Cloud Storage',
      description: 'Save and sync your catches across all devices with secure cloud storage.',
      color: 'bg-orange-100 text-orange-600'
    },
    {
      icon: <FaChartLine className="h-8 w-8" />,
      title: 'Track Progress',
      description: 'Monitor your fishing stats, personal records, and seasonal trends.',
      color: 'bg-red-100 text-red-600'
    },
    {
      icon: <FaShare className="h-8 w-8" />,
      title: 'Easy Sharing',
      description: 'Share your catches with friends and fishing communities instantly.',
      color: 'bg-indigo-100 text-indigo-600'
    }
  ]

  return (
    <section id="features" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Powerful Features for Every Angler
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Everything you need to measure, identify, and track your catches in one powerful app.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className={`inline-flex p-4 rounded-lg ${feature.color} mb-6`}>
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features